<template>

    <button :disabled="disabled || isLoading" v-tooltip="tooltipConfig" :type="(submit) ? 'submit' : 'button'" class="btn" :class="buttonClasses">

        <div v-if="!isLoading" class="d-flex gap-1" :class="buttondivClasses">
            <i v-if="icon" :class="icon"></i>
            <span v-if="text">{{ text }}</span>
        </div>

        <div v-else  class="d-flex gap-1" :class="buttondivClasses" >
            <i class="ri-restart-line rotate"></i>
            <span v-if="loadingText">{{ loadingText }}</span>
        </div>
        
    </button>

</template>

<script>
export default {
    props: {
        text: {
            type: String,
        },
        type: {
            type: String,
            default: 'info',
        },
        size:{
            type: String,
        },
        icon: {
            type: String,
        },
        submit: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        alignText: {
            type: String,
            default: 'center'
        },
        widthMax:{
            type: Boolean,
            default: false,
        },
        isLoading:{
            type: Boolean,
            default: false,
        },
        loadingText:{
            type: String
        },
        tooltip: {
            type: String
        },
        totooltipPlacement:{
            type: String,
            default: 'top'
        }
    },
    data() {
        return {
            senhaVisivel: false,
        };
    },
    computed: {
        buttonClasses() {

            return {
                'btn-info'               : this.type == 'info',
                'btn-danger'             : this.type == 'danger',
                'btn-success'            : this.type == 'success',
                'btn-warning'            : this.type == 'warning',
                'btn-sm'                 : this.size == 'small',
                'btn-lg'                 : this.type == 'large',
                'btn-light'              : this.type == 'light',
                'w-100'                  : this.widthMax
            };

        },
        buttondivClasses(){
            return {
                'justify-content-start'  : this.alignText == 'left',
                'justify-content-center' : this.alignText == 'center',
                'justify-content-end'    : this.alignText == 'rigth',
            }
        },
        tooltipConfig(){
            return {content: this.tooltip, placement: this.totooltipPlacement}
        }, 
    },
    methods: {
    },
};
</script>